import { CSS_TABLE_COLUMNS } from "csi/constants";
import Spec from "csi/core/Spec";
import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import csiHeading from "csi/heading/_base";
import locale from "csi/locale";
import Key from "csi/core/Key";
import reflection from "csi/reflection";
import ReflectionAttribute from "csi/reflection/ReflectionAttribute";
import ColumnMap from "csi/table/matrix/ColumnMap";
import xml from "csi/xml";
import declare from "dojo/_base/declare";
import _ from "lodash";

/** MatrixClass for the DataSheetItemsImportConfiguration integermap AttributeColumnMap and ItemUniqueIDColumnMap*/
const AttributeColumnMatrix = declare(ColumnMap, {
	/** @property {string} mapKeyColumnId - attribute id of column class that holds unique id for column */
	mapKeyColumnId: "Node Name",

	/** @property {string} lineItemNodeType - Node type from which the attributes will be displayed as column. Example, "RecipeLineItem", "FormulatedMaterial" */
	lineItemNodeType: null,

	/** @property {string} topHeaderLabelRes - Resource ID for the top level header label */
	topHeaderLabelRes: null,

	/**
	 * Query for all applicable reflection Attribute on the line item : Enable, Editable, of supported attribute types: 
	 * For "ItemUniqueIDColumnMap"  {string, Enum}
	 * For "AttributeColumnMap" {string, integer, double}
	 */
	_getRefAttributes(h: Heading): ReflectionAttribute[] {
		const { lineItemNodeType } = this;
		let reflectionAttributes = reflection.getClass(lineItemNodeType).getAttributes(false, true);

		if (h.m_name == "ItemUniqueIDColumnMap") {
			reflectionAttributes = reflectionAttributes
				.filter((rca) => ([xml.ATTR_STRING, xml.ATTR_ENUM].includes(rca.getType())) && rca.isEnabled);
		} else {
			// "AttributeColumnMap" matrix
			reflectionAttributes = reflectionAttributes
				.filter((rca) => ([xml.ATTR_STRING, xml.ATTR_INTEGER, xml.ATTR_DOUBLE].includes(rca.getType())) && rca.isEnabled && !rca.isHidden && !rca.isReadOnly);
		}

		return _.sortBy(reflectionAttributes, (rca) => rca.attributeId);
	},

	/**
	 * @override
	 * Add header to the top of the AttributeColumnMap / ItemUniqueIDColumnMap matrix
	 */
	getColumnSpecs(ctx: Context, h: Heading): Spec[] {
		// Create a sub-Spec for each ConfigurableAttribute
		const { lineItemNodeType } = this;
		const refAttributes = this._getRefAttributes(h);
		const subs = [];

		for (let i = 0; i < refAttributes.length; i++) {
			const rca = refAttributes[i];
			const { attributeId } = rca;
			const key = new Key({
				id: h.m_name,
			});

			const heading = ctx.view.getHeading(key);
			heading.bCopy = true;

			const params = {
				css: CSS_TABLE_COLUMNS,
				columnIndex: i,
				columnUrl: attributeId,
				heading,
				headerParams: {
					multiLineText: locale.typeId(lineItemNodeType, attributeId),
				},
				index: attributeId,
			};

			const sc = new Spec(params);
			sc.setQuerySpec(csiHeading.getQuerySpec(ctx, sc));

			subs.push(sc);
		}

		// Top level Spec
		const spec = new Spec({
			css: CSS_TABLE_COLUMNS,
			heading: h,
			headerParams: {
				multiLineText: locale.resource(this.topHeaderLabelRes),
				colSpan: subs.length,
			},
		});

		spec.subs = subs;
		return [spec];
	},
});

export = AttributeColumnMatrix;